;(function($){
$(document).ready(function(){

/* Collection grid: the mobile carousel (.sensory-mobile-slider) has been removed.
   The grid now stacks two-across on phones via Bootstrap column classes. */

/* All remaining sliders: autoplay off so content stays still while people read,
   and dots on wherever there are no arrows so it's clear there is more to see. */

var $sliderInsta = $('.instagram-mobile-slider');
var slickInitialized = false;

function instaSlider() {
  if (window.innerWidth <= 767) {
    if (!slickInitialized) {
      $sliderInsta.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: false,
        dots: true,
        arrows: false,
        centerMode: true,
        centerPadding: '0px',
      });
      slickInitialized = true;
    }
  } else {
    if (slickInitialized) {
      $sliderInsta.slick('unslick');
      slickInitialized = false;
    }
  }
}

instaSlider();

$(window).on('resize', function () {
  instaSlider();
});


$('.home-prd-slider').slick({
  slidesToShow: 4,  // Desktop
  slidesToScroll: 1,
  infinite: true,
  autoplay: false,
  dots: true,  
  arrows: false, 
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 600, // Mobile
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$('.sensory-prd-slider').slick({
  slidesToShow: 4,  // Desktop
  slidesToScroll: 1,
  infinite: true,
  autoplay: false,
  dots: true,  
  arrows: false, 
  centerMode: true,
  centerPadding: '0px',
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 767, // Mobile
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$('.home-review-slider').slick({
  slidesToShow: 3,  // Desktop
  slidesToScroll: 1,
  infinite: true,
  autoplay: false,
  dots: false,  
  centerMode: true,
  centerPadding: '0px',
  arrows: true, 
  prevArrow: '<button class="slick-prev"><i class="fa fa-long-arrow-left"></i></button>',
  nextArrow: '<button class="slick-next"><i class="fa fa-long-arrow-right"></i></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 767, // Mobile
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$('.home-work-slider').slick({
  slidesToShow: 3,  // Desktop
  slidesToScroll: 1,
  infinite: true,
  autoplay: false,
  dots: true,  
  arrows: false, 
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 600, // Mobile
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$('.home-prd-slider2').slick({
  slidesToShow: 3,  // Desktop
  slidesToScroll: 1,
  infinite: true,
  autoplay: false,
  rows: 2,
  dots: true,          // Dots enabled
  arrows: false,        // Arrows enabled
  responsive: [
    {
      breakpoint: 1024, // Tablet
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 600, // Mobile
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$('.home-blog-slider').slick({
  slidesToShow: 2,  // Desktop
  slidesToScroll: 1,
  infinite: true,
  autoplay: false,
  dots: true,
  arrows: false,
  centerMode: true,
  centerPadding: '40px', 
  responsive: [
    {
      breakpoint: 1024, // Tablet
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 600, // Mobile
      settings: {
        slidesToShow: 1
      }
    }
  ]
});


$('.home-testimonial-slider').slick({
  slidesToShow: 1,  // Desktop
  slidesToScroll: 1,
  infinite: true,
  autoplay: false,
  dots: true,          // Dots enabled
  arrows: false,        // Arrows enabled
  responsive: [
    {
      breakpoint: 1024, // Tablet
      settings: {
        slidesToShow: 1
      }
    },
    {
      breakpoint: 600, // Mobile
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$('.pdp-testimonial-slider').slick({
  slidesToShow: 3,  // Desktop
  slidesToScroll: 1,
  infinite: true,
  autoplay: false,
  dots: true,          // Dots enabled
  arrows: false,        // Arrows enabled
  centerMode: true,
  centerPadding: '0px',
  responsive: [
    {
      breakpoint: 1024, // Tablet
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 991, // Tablet
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 767, // Mobile
      settings: {
        slidesToShow: 1
      }
    }
  ]
});



$('.fc-main-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  asNavFor: '.fc-thumbnail-slider',
  prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left"></i></button>',
  nextArrow: '<button class="slick-next"><i class="fa fa-angle-right"></i></button>'
});

$('.fc-thumbnail-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.fc-main-slider',
  dots: false,
  focusOnSelect: true,
  arrows: false,
  infinite: true,
});


});
})( slickJQ );
function increment() {
var quantityInput = document.getElementById("quantity");
var currentValue = parseInt(quantityInput.value);
quantityInput.value = currentValue + 1;
}

function decrement() {
var quantityInput = document.getElementById("quantity");
var currentValue = parseInt(quantityInput.value);
if (currentValue > 1) {
  quantityInput.value = currentValue - 1;
}
}